import { Toast } from "bootstrap";

document.addEventListener("DOMContentLoaded", function () {
  const toastEl = document.getElementById("newsletterToast");
  if (toastEl) {
    const toast = new Toast(toastEl, { delay: 5000 });
    toast.show();
  }
});
